import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Note_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_NOTE_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Note Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    NOTE_TITLE:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Note Title', columnResourceName: 'colNoteTitle', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 100}},
    NOTE_URL:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Note URL', columnResourceName: 'colNoteURL', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

var NoteSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_NOTE_ID',
        id_ui: 'WB_NOTE_ID',
        name:  'NOTE_TITLE'},


    searchProviderFields: vUI_Note_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Note_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var NoteSearchProfileById: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id",
    renderOptions: { ui5ResourceId: "NoteSearchProfileById" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'NOTE_ID', renderOptions: { }},
        {profileFilterName: 'Title',     searchProviderFieldId: 'NOTE_TITLE', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'NOTE_ID','NOTE_TITLE',
        "CREATED_DTTS",
        "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: NoteSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

var NoteSearch: ISearch = {
    searchName: "Find Note",
    renderOptions: { ui5ResourceId: "NoteSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [NoteSearchProfileById]
}
PAEnvironment.registerBusinessObjectSearch("NoteBO", "Note", NoteSearch, "Note Search")

export {NoteSearch}